import { useState, useEffect, useContext } from 'react';
import { Typography, Box, TextButton, Form } from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';
import { useVendorTaxonomyCodes, useMutateVendorTaxonomyCodes } from 'helpers/vendor';
import { ToastContext } from 'contexts';

import { TaxonomyCodePicker, StickyBar } from 'components';

const TaxonomyCodes = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedTaxonomyCodes, setSelectedTaxonomyCodes] = useState([]);
  const { triggerToast } = useContext(ToastContext);

  const { data: vendorCodes, isLoading: loadingTaxonomyCodes } = useVendorTaxonomyCodes();
  const { mutate, isLoading: isSaving } = useMutateVendorTaxonomyCodes();

  useEffect(() => {
    if (!loadingTaxonomyCodes) {
      setSelectedTaxonomyCodes(vendorCodes);
    }
  }, [vendorCodes, loadingTaxonomyCodes]);

  return (
    <>
      <Typography variant="h1" component="h2">
        {t('settings.commodity_codes.title')}
      </Typography>
      <Form
        onSubmit={() =>
          mutate(selectedTaxonomyCodes, {
            onSuccess: () =>
              triggerToast({
                message: t('settings.save_success'),
                variant: 'success',
              }),
            onError: () => triggerToast({ message: t('generic_error') }),
          })
        }
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box maxWidth="1200px" mb={7}>
              <Typography
                component="h3"
                sx={{ my: 3, fontSize: theme => theme.spacing(3), fontWeight: 'normal' }}
              >
                {t('settings.commodity_codes.select_instructions')}
              </Typography>
              <TaxonomyCodePicker
                isLoading={isLoading}
                selectedTaxonomyCodes={selectedTaxonomyCodes}
                setIsLoading={setIsLoading}
                setSelectedTaxonomyCodes={setSelectedTaxonomyCodes}
                variant="loose"
              />
            </Box>
            <StickyBar
              id="taxonomy-codes-bottom"
              tabIndex={-1}
              sx={{
                width: 'auto',
                left: theme => ({ xs: 0, sm: theme.widths.sideNav }),
                padding: theme => `0 ${theme.spacing(5)}`,
                backgroundColor: theme => theme.palette.background.main,
                boxShadow: '0px -0.5px 0px 0px rgb(0 0 0 / 12%)',
              }}
            >
              <TextButton
                type="submit"
                variant="contained"
                color="primary"
                isLoading={isSaving}
                disabled={isLoading}
                label={t('settings.save')}
                sx={{ left: 5 }}
              />
            </StickyBar>
          </form>
        )}
      </Form>
    </>
  );
};

export default TaxonomyCodes;
